// extracted by mini-css-extract-plugin
export default {"container":"ListRelationalGroup_container__cimMY"};